import { gql } from 'apollo-angular';
import Project from '../../../../interfaces/project';
import { Paginator, PaginatorInfo } from '../../../../types/paginator';

export type SearchForDealInput = {
  search: string;
  searchLike: string;
};
export type SearchForDealResult = {
  search_projects: Paginator<Project, PaginatorInfo>;
};

const SEARCH_FOR_DEAL = gql<SearchForDealResult, SearchForDealInput>`
  query searchForDeal($search: String!, $searchLike: String!) {
    search_projects(
      name: $searchLike
      orderByInstr: [{ column: NAME, search: $search, order: ASC }]
      first: 10
    ) {
      data {
        id
        name
      }
    }
  }
`;

export const queries = { SEARCH_FOR_DEAL };
